import { APIResponse, Events } from "../../../@types";
const URL = import.meta.env.VITE_API_URL;

export async function getEvents(seasonId: number, episodeId: number) {
  const requestOptions: RequestInit = {
    method: "GET",
    redirect: "follow",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
    },
  };

  const result = (await (
    await fetch(
      URL + `/seasons/${seasonId}/events?episodeId=${episodeId}`,
      requestOptions
    )
  ).json()) as APIResponse;
  if (!result.success) return undefined;
  return result.data as Events;
}
